module.exports = __webpack_public_path__ + "img/cls-banner.bd5baebd.png";